import { useEffect } from 'react';

const IMAGES = [
  '/webtoon/webtoon_001.jpg',
  '/webtoon/webtoon_002.jpg',
  '/webtoon/webtoon_003.jpg',
  '/webtoon/webtoon_004.jpg',
  '/webtoon/webtoon_005.jpg',
];

export default function WebtoonPage() {
  useEffect(() => {
    document.body.style.overflow = 'auto';
    document.body.style.position = 'static';
    document.body.classList.add('show-scrollbar');
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.classList.remove('show-scrollbar');
    };
  }, []);

  return (
    <div className="bg-white min-h-screen flex flex-col items-center pt-[69px]">
      {IMAGES.map((src, i) => (
        <img
          key={src}
          src={src}
          alt={`webtoon ${i + 1}`}
          className="w-full max-w-[800px]"
        />
      ))}
    </div>
  );
}
